import { EmptyStateBody, Label, Spinner, Title } from '@patternfly/react-core'
import { Table, Td, Tr } from '@patternfly/react-table'
import * as React from 'react'

import type { ExtractedPdfInfo } from '@app/domain/visit/visit.helpers'
import { SmallButton } from '@app/utils/styles/small-button'

interface Props {
  isDownloading: boolean
  instrumentPdfs: ExtractedPdfInfo[]
  getEntryPdf: (entryId: string, templateId: string) => void
}

export const InstrumentReports = ({
  isDownloading,
  instrumentPdfs,
  getEntryPdf,
}: Props) => {
  const [activeDownloadId, setActiveDownloadId] = React.useState<string | null>(
    null,
  )

  React.useEffect(() => {
    if (!isDownloading) {
      setActiveDownloadId(null)
    }
  }, [isDownloading])

  {
    const onClick = React.useCallback(
      (entryId: string, templateId: string) => {
        getEntryPdf(entryId, templateId)
        setActiveDownloadId(templateId)
      },
      [getEntryPdf],
    )

    return (
      <>
        <Title headingLevel="h2" size="xl">
          Instrument Reports
        </Title>
        <div style={{ maxWidth: '50%' }}>
          {instrumentPdfs.length > 0 ? (
            <>
              <Table aria-label="Instrument Reports table" isStriped>
                {instrumentPdfs.map((pdf) => (
                  <Tr key={pdf.id}>
                    <Td width={50}>
                      {pdf.isConsent && <Label color="green">Consent</Label>}{' '}
                      {pdf.label ?? pdf.id}
                    </Td>
                    <Td>
                      {' '}
                      <SmallButton
                        variant="secondary"
                        isDisabled={pdf.isDisabled || isDownloading}
                        onClick={() => onClick(pdf.entryId, pdf.id)}
                      >
                        Download PDF
                      </SmallButton>
                      {isDownloading && activeDownloadId === pdf.id ? (
                        <>
                          <Spinner size="md" style={{ marginLeft: 6 }} />
                        </>
                      ) : null}
                    </Td>
                  </Tr>
                ))}
              </Table>
            </>
          ) : (
            <EmptyStateBody>
              There are no instrument reports configured.
            </EmptyStateBody>
          )}
        </div>
      </>
    )
  }
}
